import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "./../../select/Select";
import * as reactSpark from "react-spark";

const { Stack } = reactSpark;
const { Item } = Stack;

const days = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31"
].map((i) => ({ text: i, value: i }));

const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
].map((t, i) => ({
    text: t,
    value: i + 1
}));

function daysInMonth(month, year) {
    switch (month) {
        case 2:
            return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29: 28;
        case 4: case 6: case 9: case 11:
            return 30;
        default:
            return 31;
    }
}

function isValidDate(month, day, year) {
    return day <= daysInMonth(month, year);
}

function generateYearsArray(length, offset) {
    const arr = [];

    for (let i = 0; i < length; i++) {
        const year = new Date().getFullYear() - offset - i;
        arr.push(year.toFixed());
    }

    return arr;
}

const years = generateYearsArray(100, 18).map((i) => ({ text: i, value: i }));

export const birthMonthValidation = {
    validateOn: ["blur"],
    required: true,
    message: {
        default: "Please select a month"
    }
};

export const birthDayValidation = {
    validateOn: ["blur"],
    required: true,
    message: {
        default: "Please select a day",
        pattern: {
            invalid: "Not a valid day",
        },
        required: "This field is required"
    },
    checkValidity: (val, dependentVals) => {
        if (dependentVals['birthMonth'] && dependentVals['birthYear']) {
            let day = Number(val);
            let month = Number(dependentVals['birthMonth']);
            let year = Number(dependentVals['birthYear']);

            if (!isValidDate(month, day, year)) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'invalid'
                    }
                }
            };
        }

        return true;
    }
};

export const birthYearValidation = {
    validateOn: ["blur"],
    required: true,
    message: {
        default: "Please select a year"
    }
};

class Birthdate extends Component {
    static parseBirthday(formValues) {
        const { birthYear, birthMonth, birthDay } = formValues;
        const parsedMonth =
            birthMonth > 9 ? birthMonth : `0${Number(birthMonth)}`;
        const parsedDay = birthDay > 9 ? birthDay : `0${Number(birthDay)}`;
        return `${birthYear}-${parsedMonth}-${parsedDay}`;
    }

    static clearForm(parsedForm) {
        delete parsedForm.birthDay;
        delete parsedForm.birthMonth;
        delete parsedForm.birthYear;
        return parsedForm;
    }

    getMonth() {
        const { month, birthdate } = this.props;

        return month || birthdate
            ? (new Date(birthdate).getUTCMonth() + 1).toString()
            : undefined;
    }

    getDay() {
        const { day, birthdate } = this.props;

        return day || birthdate
            ? new Date(birthdate).getUTCDate().toString()
            : undefined;
    }

    getYear() {
        const { year, birthdate } = this.props;

        return year || birthdate
            ? new Date(birthdate).getUTCFullYear().toString()
            : undefined;
    }

    render() {
        return (
            <Stack splitAt="small">
                <Item breakpoint="small" width="fourth">
                    <Select
                        id="birthMonth"
                        name="birthMonth"
                        type="text"
                        placeholder="Date of Birth"
                        placeholderText="Month"
                        options={months}
                        validation={birthMonthValidation}
                        dependentFields={['birthDay']}
                        value={this.getMonth()}
                        usePlaceholderOption
                    />
                </Item>
                <Item breakpoint="small" width="fourth">
                    <Select
                        id="birthDay"
                        name="birthDay"
                        type="text"
                        placeholder={"\u00A0"}
                        placeholderText="Day"
                        options={days}
                        validation={birthDayValidation}
                        value={this.getDay()}
                        usePlaceholderOption
                    />
                </Item>
                <Item breakpoint="small" width="fourth">
                    <Select
                        id="birthYear"
                        name="birthYear"
                        type="text"
                        placeholder={"\u00A0"}
                        placeholderText="Year"
                        options={years}
                        validation={birthYearValidation}
                        dependentFields={['birthDay']}
                        value={this.getYear()}
                        usePlaceholderOption
                    />
                </Item>
                {this.props.children && (
                    <Item breakpoint="small" width="fourth">
                        {this.props.children}
                    </Item>
                )}
            </Stack>
        );
    }
}

Birthdate.defaultProps = {};

Birthdate.propTypes = {
    birthdate: PropTypes.string,
    children: PropTypes.node
};

export default Birthdate;
